<template>
    <el-dialog :visible.sync="visible" :before-close="handleClose" :fullscreen="true">
        <div style="width:1080px; margin:0 auto;">
            <div id="printTable" style="width:1080px;"></div>
        </div>
    </el-dialog>
</template>

<script>
export default {
  created() {
    let _this = this;
    if (window.matchMedia) {
      var mediaQueryList = window.matchMedia("print");
      mediaQueryList.addListener(function(mql) {
        if (mql.matches) {
          //打印成功
          _this.$emit("success");
        } else {
          //打印失败
          _this.$emit("close");
        }
      });
    }
  },
  data() {
    return {
      visible: false
    };
  },
  props: {
    table: Array,
    show: Boolean,
    node: String
  },
  methods: {
    handleClose() {
      this.show = false;
    }
  },
  watch: {
    show: function(value) {
      this.visible = value;
      let _node = this.node;
      if (value) {
        setTimeout(function() {
          document.getElementById("printTable").innerHTML = "";
          document
            .getElementById("printTable")
            .appendChild(document.getElementById(_node).cloneNode(true));
          document
            .getElementById("printTable")
            .getElementsByClassName("el-table__header")[0].style.width =
            "auto";
          document
            .getElementById("printTable")
            .getElementsByClassName("el-table__body")[0].style.width =
            "auto";
          window.print();
        }, 500);
      } else {
        this.$emit("close");
      }
    }
  }
};
</script>
